/**
 * Cart page (task G1).
 *
 * The page works fully without this file: quantity fields are named
 * `updates[]`, remove is a real link to `line.url_to_remove`, and the form
 * posts to /cart. This only upgrades those to AJAX so the page does not
 * reload on every change.
 *
 * Like the drawer, it never computes a total — it asks the server to
 * re-render this section and swaps the result in, so the cart page and the
 * drawer always agree.
 */
(function () {
  'use strict';

  var V = window.Velocity;
  if (!V) return;

  var SECTION_ID = 'main-cart';

  class CartPage extends V.Element {
    init() {
      this.sectionId = this.dataset.sectionId || SECTION_ID;
      this.announcer = this.querySelector('[data-cart-announcer]');
      this.bind();

      var self = this;
      // Keep in step if the drawer changes the cart while this page is open.
      this.listen(V.EVENTS.cartUpdate, function (data) {
        if (data && data.silent) return;
        self.refresh();
      });
    }

    bind() {
      var self = this;

      this.addEventListener('click', function (e) {
        var remove = e.target.closest('[data-remove]');
        if (remove) {
          e.preventDefault();
          self.change(remove.dataset.key, 0);
          return;
        }
        var down = e.target.closest('[data-qty-down]');
        var up = e.target.closest('[data-qty-up]');
        if (!down && !up) return;
        e.preventDefault();
        var input = (down || up).closest('[data-qty]').querySelector('[data-qty-input]');
        var next = parseInt(input.value, 10) + (up ? 1 : -1);
        if (next < 0) return;
        self.change(input.dataset.key, next);
      });

      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-qty-input]');
        if (input) {
          var value = parseInt(input.value, 10);
          self.change(input.dataset.key, isNaN(value) || value < 0 ? 0 : value);
          return;
        }
        // Cart note saves on blur rather than on every keystroke.
        var note = e.target.closest('#cart-note');
        if (note) self.saveNote(note.value);
      });
    }

    setBusy(isBusy) {
      this.setAttribute('aria-busy', isBusy ? 'true' : 'false');
    }

    change(key, quantity) {
      var self = this;
      this.setBusy(true);

      return V.postJSON(window.Velocity.routes.cartChange, {
        id: key,
        quantity: quantity,
        sections: this.sectionId,
        sections_url: window.location.pathname
      })
        .then(function (cart) {
          self.render(cart);
          // Tell the header bubble and the drawer.
          V.publish(V.EVENTS.cartUpdate, { item_count: cart.item_count, silent: true });
        })
        .catch(function (err) {
          if (self.announcer) self.announcer.textContent = err.message || V.strings.cartError;
          return self.refresh();
        })
        .then(function () { self.setBusy(false); });
    }

    saveNote(note) {
      return V.postJSON(window.Velocity.routes.cartUpdate, { note: note });
    }

    render(cart) {
      if (!cart || !cart.sections || !cart.sections[this.sectionId]) return this.refresh();
      var fragment = document.createRange().createContextualFragment(cart.sections[this.sectionId]);
      this.swap(fragment.querySelector('cart-page'));
    }

    refresh() {
      var self = this;
      return V.fetchSection(this.sectionId, window.location.pathname)
        .then(function (fragment) { self.swap(fragment.querySelector('cart-page')); });
    }

    swap(next) {
      if (!next) return;
      var activeKey = document.activeElement && document.activeElement.dataset
        ? document.activeElement.dataset.key
        : null;

      this.innerHTML = next.innerHTML;
      this.announcer = this.querySelector('[data-cart-announcer]');

      if (activeKey) {
        var restored = this.querySelector('[data-key="' + activeKey + '"]');
        if (restored && restored.focus) restored.focus();
      }
    }
  }

  V.define('cart-page', CartPage);
})();
